import type { ChatPreferences } from "@app/store/chat/ChatState";

// 60px nav bar ($navigation-bar-height: 3.75rem) plus 16px of clearance beneath it
export const CHAT_NAV_BAR_CLEARANCE = 76;

export const CHAT_DEFAULT_HEIGHT = 600;
export const CHAT_DEFAULT_WIDTH = 400;
// 2.5rem, matching the dashboard's FloatButton and the map's control column so the
// collapsed launcher shares their footprint.
export const CHAT_LAUNCHER_SIZE = 40;
// A 360px-tall window is cramped for reading a conversation regardless of how much of it the
// composer eats, so the floor moved up on its own merits, independent of the composer's own
// height cap (see ChatWindow.module.scss).
export const CHAT_MIN_HEIGHT = 400;
export const CHAT_MIN_WIDTH = 360;

// The chat endpoint rejects anything longer with a 400. Capping the field is what keeps that
// from being a dead end: the rep would otherwise get the generic "Failed to send. Click to try
// again.", and every retry re-sends the same over-length text and fails identically, forever.
export const CHAT_MESSAGE_MAX_LENGTH = 8000;

// The page-context contract's cap on the ids one context sends, shared by every screen.
export const MAX_CONTEXT_IDS = 200;

// Deliberately undiscoverable: no hint text, no menu entry, matched case-insensitively against
// the trimmed field so "/CLEAR" and "  /clear  " both work, but "/clear please" is a real
// message and sends normally. Lowercase because the composer's own comparison lowercases first.
export const CHAT_CLEAR_COMMAND = "/clear";

// How far a drag has to travel vertically before it un-maximizes the window. A sideways
// drag picks up a pixel or two of vertical movement on the way, and losing a maximized
// window to that jitter is worse than needing a deliberate nudge to leave it.
export const CHAT_MAXIMIZED_DRAG_EXIT_THRESHOLD = 8;

// Gaps kept between the window and the viewport's edges. Each mirrors its pin in
// ChatAnchor.module.scss (`right: 1rem`, `bottom: 1.5rem`) that places the collapsed
// launcher, so an open window lines up with the button it grew out of. The two differ
// because the launcher's x-axis follows the dashboard's FloatButton and the map's
// control column, while its bottom gap stays at the original 1.5rem.
export const CHAT_VIEWPORT_INSET_X = 16;
export const CHAT_VIEWPORT_INSET_BOTTOM = 24;

// Mirrors mobile's deviceOptions defaults exactly: voice input on, read-aloud off. Read-aloud is
// off because speaking replies is opt-in, and mobile's slice says the same.
export const CHAT_PREFERENCE_DEFAULTS: ChatPreferences = {
  readResponsesAloud: false,
  voiceInputEnabled: true,
};

// Global class on the chat window root, so map annotations can treat clicks in the chat as not outside.
export const CHAT_SHELL_CLASS_NAME = "mmc-chat-shell";
